// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  DisruptionsAreaId,
  DisruptionsAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  DisruptionsAreaNavigation,
  DisruptionsAreaNavigationIcon,
} from './DisruptionsAreaNavigation'

const LazyDisruptionsComponent = lazy(() => import('./DisruptionsArea'))

const DisruptionsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyDisruptionsComponent />
  </SuspenseLoadingWrapper>
)

export const DisruptionsArea = {
  id: DisruptionsAreaId,
  requiredRight: BoumRight.REPORT_DISRUPTION_AREA,
  Icon: DisruptionsAreaNavigationIcon,
  NavigationComponent: DisruptionsAreaNavigation,
  route: {
    path: DisruptionsAreaRoutes.route,
    component: DisruptionsComponent,
  },
}
